import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangleIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { CONTACT, NAV } from '../../data/site';
import { INDUSTRIES } from '../../data/industries';
import { Container } from '../ui/Section';
export function Footer() {
  const solutions = NAV.find(n => n.label === 'Soluciones')?.children ?? [];
  return <footer className="bg-graphite-900 text-mist-200" data-id="element-365" data-mp="nps2az3u2tc">
      <Container className="py-16 md:py-20" data-id="element-366" data-mp="pkddqeafwxy">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_1fr_1fr_1fr]" data-id="element-367" data-mp="3s2x61hqdj75n">
          <div data-id="element-368" data-mp="3s0kh2km77wj3">
            <div className="flex items-center gap-3" data-id="element-369" data-mp="3n3kam8lfsrrg">
              <span className="flex h-9 w-9 items-center justify-center bg-brand-600 font-display text-lg font-bold text-white" data-id="element-370" data-mp="3n43s5o76de4y">
                R
              </span>
              <span className="font-display text-lg font-bold tracking-tightest text-white" data-id="element-371" data-mp="3e35m70d6ewjq">RABEMAR</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-mist-300" data-id="element-372" data-mp="39542cd7xet77">
              Infraestructura operativa para empresas. Integramos logística, Facility Management, HSE, tecnología y
              sustentabilidad en un único punto de control.
            </p>
            <p className="mt-6 font-display text-sm font-semibold uppercase tracking-[0.16em] text-accent-400" data-id="element-373" data-mp="2bcybtexs4ugb">
              Operar · Controlar · Optimizar · Escalar
            </p>
          </div>

          <nav aria-label="Soluciones" data-id="element-374" data-mp="340kiwx67uh7x">
            <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-white" data-id="element-375" data-mp="341lvj62vrbrr">Soluciones</h2>
            <ul className="mt-5 space-y-3" data-id="element-376" data-mp="381w7r0h9myf2">
              {solutions.map(s => <li key={s.to} data-id="element-377" data-mp="2u2efgb4rh30y">
                  <Link className="text-sm text-mist-300 transition-colors duration-150 hover:text-white" to={s.to} data-id="element-378" data-mp="2u5ac7w4vhlnt">
                    {s.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="Industrias" data-id="element-379" data-mp="1nn40x2x0tfyp">
            <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-white" data-id="element-380" data-mp="1no5f3g9c2ikn">Industrias</h2>
            <ul className="mt-5 space-y-3" data-id="element-381" data-mp="13mu1453ht333">
              {INDUSTRIES.slice(0, 7).map(i => <li key={i.slug} data-id="element-382" data-mp="zl8u30dn3j0t">
                  <Link className="text-sm text-mist-300 transition-colors duration-150 hover:text-white" to={`/industrias#${i.slug}`} data-id="element-383" data-mp="us5ykmpaxzhz">
                    {i.name}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-384" data-mp="fuvmpc8qyrlq">
            <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-white" data-id="element-385" data-mp="fudjtwrkxf4u">Contacto comercial</h2>
            <ul className="mt-5 space-y-4 text-sm text-mist-300" data-id="element-386" data-mp="bu3cafo52gnv">
              <li className="flex gap-3" data-id="element-387" data-mp="6v8n8vzkvvvb">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-400" aria-hidden="true" data-id="element-388" data-mp="6wbej50tc0br" />
                <span data-id="element-389" data-mp="265i5j6gcyy8d">{CONTACT.address}</span>
              </li>
              <li className="flex gap-3" data-id="element-390" data-mp="219jcv6nzyu25">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-400" aria-hidden="true" data-id="element-391" data-mp="216f2frjxv231" />
                <a className="transition-colors duration-150 hover:text-white" href={CONTACT.phoneHref} data-id="element-392" data-mp="28q6dwy1sg97x">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex gap-3" data-id="element-393" data-mp="2iic17uh3i2gs">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-400" aria-hidden="true" data-id="element-394" data-mp="2ngneygaigx4a" />
                <a className="break-all transition-colors duration-150 hover:text-white" href={`mailto:${CONTACT.email}`} data-id="element-395" data-mp="1ptel9y0cwhr7">
                  {CONTACT.email}
                </a>
              </li>
              <li className="text-mist-300" data-id="element-396" data-mp="1zrcc8t9losni">
                Referente comercial: <span className="text-white" data-id="element-397" data-mp="1zq16inwlhatr">{CONTACT.commercialContact}</span>
              </li>
            </ul>

            <p className="mt-6 flex gap-2 border border-accent-500/40 bg-accent-500/10 p-3 text-[11px] leading-relaxed text-accent-300" data-id="element-398" data-mp="23ql2ho5fm8eb">
              <AlertTriangleIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-399" data-mp="3f7bdrloppqes" />
              <span data-id="element-400" data-mp="3dqe2n933rov6">{CONTACT.validationNote}</span>
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-mist-300 md:flex-row md:items-center md:justify-between" data-id="element-401" data-mp="38scjko5ofpjp">
          <p data-id="element-402" data-mp="3nqeq97808r56">© {new Date().getFullYear()} Rabemar Servicios Integrales. Todos los derechos reservados.</p>
          <p data-id="element-403" data-mp="3is3f8t5z4ald">Pergamino, Buenos Aires — Cobertura en todo el territorio argentino.</p>
        </div>
      </Container>
    </footer>;
}